import { render, staticRenderFns } from "./examSystem2024.vue?vue&type=template&id=40c084ff&scoped=true&"
import script from "./examSystem2024.vue?vue&type=script&lang=js&"
export * from "./examSystem2024.vue?vue&type=script&lang=js&"
import style0 from "./examSystem2024.vue?vue&type=style&index=0&id=40c084ff&lang=scss&scoped=true&"
import style1 from "./examSystem2024.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c084ff",
  null
  
)

export default component.exports